module.exports = __webpack_public_path__ + "img/image.d4025fc.png";